import React from 'react';

import Checkbox from 'Core/Components/Checkbox';

class TagFilter extends React.Component {
  constructor (props) {
    super(props);

    this.state = {
      activeFilters: []
    };

    this.getFilterName = this.getFilterName.bind(this);
    this.getFilterValue = this.getFilterValue.bind(this);
    this.filterIsActive = this.filterIsActive.bind(this);
    this.renderAllButton = this.renderAllButton.bind(this);
    this.renderFilterButton = this.renderFilterButton.bind(this);
    this.propogateFilteredList = this.propogateFilteredList.bind(this);
  }

  getFilterName (filter) {
    if (typeof filter === 'object' && 'name' in filter) return filter.name;
    return filter;
  }

  getFilterValue (filter) {
    if (typeof filter === 'object' && 'value' in filter) return filter.value;
    return filter;
  }

  filterIsActive (filter) {
    let { activeFilters } = this.state;
    let value = this.getFilterValue(filter);
    return activeFilters.indexOf(value) >= 0;
  }

  renderAllButton () {
    let { activeFilters } = this.state;
    const { allOption } = this.props;
    const showingAll = activeFilters.length === 0;
    const label = allOption || 'Show All';
    const toggle = () => {
      // console.log('toggling');
      if (showingAll) return;
      // console.log('not showing all, attempting to show all from', activeFilters);
      activeFilters = [];
      this.setState({ activeFilters }, () => this.propogateFilteredList());
    };
    return (
      <div className="TagFilter-Option" onClick={toggle}>
        <Checkbox checked={showingAll} />
        <label>{label}</label>
      </div>
    );
  }

  renderFilterButton (filter) {
    let { activeFilters } = this.state;
    let { single } = this.props;
    let name = this.getFilterName(filter);
    let value = this.getFilterValue(filter);
    let isActive = this.filterIsActive(filter);
    let toggle = () => {
      if (isActive && single) {
        activeFilters = [];
        this.setState({ activeFilters }, this.propogateFilteredList);
      } else if (isActive) {
        activeFilters.splice(activeFilters.indexOf(value), 1);
        this.setState({ activeFilters }, this.propogateFilteredList);
      } else if (single) {
        activeFilters = [ value ];
        this.setState({ activeFilters }, this.propogateFilteredList);
      } else {
        activeFilters.push(value);
        this.setState({ activeFilters }, this.propogateFilteredList);
      }
    };
    return (
      <div key={value} className="TagFilter-Option" onClick={toggle}>
        <Checkbox checked={isActive} />
        <label>{name}</label>
      </div>
    );
  }

  propogateFilteredList () {
    let { activeFilters } = this.state;
    let { list, onFilter } = this.props;
    // console.log('propogating the filtered list starting from', list);
    if (typeof onFilter !== 'function' || typeof list !== 'object') return;
    if (!activeFilters.length) return onFilter(list);

    let filteredList = list.filter(item => {
      if (typeof item !== 'object' || !'tags' in item) return false;
      if (!Array.isArray(item.tags)) return false;
      let pass = true;
      activeFilters.forEach(filter => {
        if (!item.tags.includes(filter)) pass = false;
      });
      return pass;
    });
    onFilter(filteredList);
  }

  render () {
    const { filters } = this.props;
    const allButton = this.renderAllButton();
    const filterList = !filters ? null : filters.map(this.renderFilterButton);
    return (
      <div className="TagFilter">
        {allButton}
        {filterList}
      </div>
    )
  }
};

export default TagFilter;



// WEBPACK FOOTER //
// ./client/Core/Components/TagFilter.jsx